/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable jsx-a11y/label-has-for */
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Transition from 'react-transition-group/Transition';
import useStyle from '../../../pulpo_visualizer/fields/inspection_checklist/checklistDisplay.module.scss';
import Button from '../../../components/button';
import Clickable from '../../../components/clickable/Clickable';
import Collapsible from '../../../components/collapsible/Collapsible';

export default function CheckListDisplay(props) {
  const { useFieldData, handleItemStatusChange, check_list_answers=false,
  displayChecklist } = props;
  const [useRemarks, handleActionRemarks] = useState({
    openRemarks: false,
    remarkVal: ''
  });
  let transitionStyles = {
    entered: { maxHeight: '100vh' }
  };
  let labelStyles = {
    bottom: 43,
    fontSize: 15
  };
  let textareaStyles = {
    margin: '12px',
    border: '1px solid #E6EAEE',
    borderRadius: '4px',
    width: '250px',
    maxHeight: 350,
    minHeight: 40,
    resize: 'block',
    height: 40,
    marginTop: '6px'
  };
  const handleStatusFlag = (mainCheckId, subCheckId, isSuccess) => {
    let useStatus;

    if (typeof isSuccess === 'boolean' && !isSuccess) {
      if (check_list_answers?.[mainCheckId] && subCheckId in check_list_answers?.[mainCheckId]) {
        useStatus = check_list_answers?.[mainCheckId]?.[subCheckId]?.check_lilst_status
          ? useStyle.inactive
          : useStyle.active;
      } else {
        useStatus = useStyle.inactive;
      }
    } else if (isSuccess === 'N/A') {
      if (check_list_answers?.[mainCheckId] && subCheckId in check_list_answers?.[mainCheckId]) {
        if (check_list_answers?.[mainCheckId]?.[subCheckId]?.check_lilst_status !== 'N/A') {
          useStatus = useStyle?.inactive;
        } else if (check_list_answers?.[mainCheckId]?.[subCheckId]?.check_lilst_status === 'N/A') {
          useStatus = useStyle?.active;
        }
      }
    } else {
      useStatus = check_list_answers?.[mainCheckId]?.[subCheckId]?.check_lilst_status === true
        ? useStyle.active
        : useStyle.inactive;
    }
    return useStatus;
  };

  const checkStatusDot = (mainCheckId, subCheckId) => {
    let useDot;
    if (check_list_answers?.[mainCheckId] && subCheckId in check_list_answers?.[mainCheckId]) {
      if (check_list_answers?.[mainCheckId]?.[subCheckId]?.check_lilst_status === true) {
        useDot = useStyle.success1;
      } else if (check_list_answers?.[mainCheckId]?.[subCheckId]?.check_lilst_status === false) {
        useDot = useStyle.failure1;
      } else if (check_list_answers?.[mainCheckId]?.[subCheckId]?.check_lilst_status === 'N/A') {
        useDot = useStyle.na1;
      } else {
        useDot = useStyle.untouched;
      }
    } else {
      useDot = useStyle.untouched;
    }
    return useDot;
  };

  const handleRemarksPerChecklist= (checkListId, subChecklistId, value) => {
    let remarkStatus = check_list_answers?.[checkListId]?.[subChecklistId]?.check_lilst_status || false;
    handleItemStatusChange(useFieldData?.id, checkListId, subChecklistId, remarkStatus, value);
  };


  let Tag = Clickable;
  const { openRemarks, remarkVal, checkId, sub_checkId, satisfiedRemark } = useRemarks;
  return (
    <div className={useStyle.fullWidth}>
      <div className={useStyle.itemWrapper}>
        {useFieldData?.schema?.fields?.length > 0
        && useFieldData.schema.fields.filter(field => field.type === 'inspection')?.map(eachCheck => (
          <>
            <Collapsible
              title={eachCheck?.title || 'New'}
              styleClasses={`${useStyle.checkListHeading}`}
              openOnMount
              autoheight
              offset={'1rem'}
            >
              {eachCheck?.checklist?.map(subCheck => (
                <>
                  <div className={useStyle.checklist__item}
                   style={{ marginTop: '0.8rem' }}
                  >
                    <span className={useStyle.checklist__item__data}>
                      <span
                        className={`${useStyle.statusDot} ${!check_list_answers
                           ? useStyle.untouched : checkStatusDot(eachCheck?.id, subCheck.key)}`}
                      />
                      {subCheck?.value}
                    </span>
                    <div className={useStyle.checkWrap}>
                      <div className={useStyle.standard}>
                        <div
                          className={`${useStyle.checklist__item__btnContainer} ${useStyle.checklist__item__data}`}
                        >
                          <Tag
                            className={`${useStyle.success} ${
                              handleStatusFlag(eachCheck?.id, subCheck?.key, true)
                            }`}
                            {...(Tag === Clickable && {
                              onClick: () => {
                                handleItemStatusChange(useFieldData?.id, eachCheck.id, subCheck.key, true);
                                handleActionRemarks({
                                  ...useRemarks,
                                  satisfiedRemark: true,
                                  sub_checkId: subCheck?.key,
                                  checkId: eachCheck?.id
                                });
                              }
                            })}
                          />
                          <Tag
                            className={`${useStyle.failure} ${
                              handleStatusFlag(eachCheck?.id, subCheck?.key, false)
                            }`}
                            {...(Tag === Clickable && {
                              onClick: () => {
                                handleItemStatusChange(useFieldData?.id, eachCheck.id, subCheck.key, false);
                                handleActionRemarks({
                                  ...useRemarks,
                                  satisfiedRemark: false,
                                  sub_checkId: subCheck?.key,
                                  checkId: eachCheck?.id
                                });
                             }
                            })}
                          />
                          {(useFieldData?.version_settings?.na_option || subCheck?.settings?.enable_NA)
                            && (
                              <Tag
                                className={`${useStyle.na} ${handleStatusFlag(eachCheck?.id, subCheck?.key, 'N/A')
                                  }`}
                                {...(Tag === Clickable && {
                                  onClick: () => {
                                    handleItemStatusChange(useFieldData?.id, eachCheck.id, subCheck.key, 'N/A');
                                    handleActionRemarks({
                                      ...useRemarks,
                                      satisfiedRemark: 'N/A',
                                      sub_checkId: subCheck?.key,
                                      checkId: eachCheck?.id
                                    });
                                  }
                                })}
                              />
                            )}
                        </div>
                      </div>
                      <textarea
                        rows="2"
                        defaultValue={remarkVal || ''}
                        value={check_list_answers[eachCheck.id]?.[subCheck?.key]?.checklist_remarks_list || ''}
                        onChange={(e) => { handleRemarksPerChecklist(eachCheck.id, subCheck?.key, e.target.value); }}
                        style={textareaStyles}
                        className={useStyle.remarks}
                        name={'NewReamrks'}
                        disabled={(!(checkId === eachCheck.id && sub_checkId === subCheck?.key)
                           && !check_list_answers[eachCheck.id]?.[subCheck?.key]) || displayChecklist}
                        placeholder="Remarks"
                      />
                    </div>
                  </div>
                  {openRemarks && checkId === eachCheck.id && sub_checkId === subCheck?.key && (
                    <Transition in={openRemarks} timeout={0}>
                      {state => (
                        <div
                          className={useStyle.remarkInput}
                          style={transitionStyles[state]}
                        >
                          <label style={labelStyles}>
                            <FormattedMessage
                              id="todo.details.description"
                              defaultMessage="Description"
                            />
                          </label>
                          <textarea
                            rows="2"
                            defaultValue={remarkVal || ''}
                            value={remarkVal || ''}
                            onChange={e => handleActionRemarks({
                              ...useRemarks,
                              remarkVal: e.target.value
                            })
                            }
                            style={textareaStyles}
                            name={`${remarkVal || 'new'}`}
                          />
                          <Button
                            action="teritary"
                            translationID="inspections.new.cancelBtn"
                            defaultText="Cancel"
                            onClick={() => handleActionRemarks({
                                ...useRemarks,
                                openRemarks: false
                              })
                            }
                          />
                          <Button
                            action="secondary"
                            translationID="inspections.new.addBtn"
                            defaultText="Save"
                            onClick={() => {
                              handleItemStatusChange(useFieldData?.id, eachCheck.id, subCheck.key, satisfiedRemark, remarkVal);
                              handleActionRemarks({
                                ...useRemarks,
                                openRemarks: false,
                                remarkVal: ''
                              });
                            }}
                          />
                        </div>
                      )}
                    </Transition>
                  )}
                </>
              ))}
            </Collapsible>
          </>
        ))}
      </div>
    </div>
  );
}
